__webpack_require__.p = "https://bs.fast.ax/build/premierbet-demo/1768487262/";